import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ManufacturerRequestReceivedPage() {
  return <>
      <SEO title="Submission Received — Aspect" description="Your request for manufacturer access has been received. We'll review and respond within one business day if there is a fit." data-id="element-529" />
      <div className="max-w-2xl" data-id="element-530">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-16 text-aspect-black" data-id="element-531">
          Submission received
        </h1>

        <div className="space-y-16" data-id="element-532">
          <section data-id="element-533">
            <p className="text-lg text-aspect-black/80 leading-relaxed" data-id="element-534">
              Your request for manufacturer access has been received.
            </p>
          </section>

          <section className="space-y-4" data-id="element-535">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-536">
              What happens next
            </h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-537">
              We review requests to confirm product category alignment and
              verification requirements.
            </p>
          </section>

          <section className="space-y-4" data-id="element-538">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-539">Timing</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-540">
              If there is a fit, you will hear from us within one business day.
            </p>
          </section>

          <section className="space-y-4" data-id="element-541">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-542">Reference</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-543">
              Learn more about verification, rights, and licensing in the{' '}
              <Link to="/faq#manufacturers" className="text-aspect-black underline hover:text-aspect-black/70" data-id="element-544">
                Manufacturer FAQs
              </Link>
            </p>
          </section>
        </div>
      </div>
    </>;
}